import React, { useEffect, useState } from 'react';
import { Divider, Form, Input, Button, message } from 'antd';
import {formatObjectAsDotpath} from "../../../utils/tools";
import {
    portfolioNameInput,
    portfolioDescription,
    benchmarkInput,
    targetAllocationSlider,
    objectiveSelect,
    assetClassSelect,
    assetTypeSelect,
    regionSelect,
    strategyTypeSelect
} from "./components/FormFields";


const PortfolioForm = ({ portfolioId, initialValues, handleSubmit }) => {
  const [form] = Form.useForm();
  const [equityAllocation, setEquityAllocation] = useState(initialValues?.targets?.equity); // Default to 50% for equity
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
      setEquityAllocation(initialValues?.targets?.equity);
    }
  }, [initialValues, form]);

  const onSliderChange = (value) => {
    setEquityAllocation(value);
  };

  const onSubmit = (values) => {
    const updatedValues = {
      ...values,
      'targets.equity': equityAllocation,
      'targets.fixed': 100 - equityAllocation,
    };
    const data = formatObjectAsDotpath(updatedValues, '', {}, true);
    const payload = {portfolioId, data};
    handleSubmit(payload);
    message.success(`Portfolio ${data.name} updated successfully!`);

  };

  // Modular function to render Form.Item with spacing and optional divider
  const renderFormItem = (item, key, showDivider = false) => (
    <React.Fragment key={key}>
      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
        {item}
      </div>
      {showDivider && <Divider />}
    </React.Fragment>
  );

  const formItems = [
    portfolioNameInput(),
    portfolioDescription(),
    benchmarkInput(),
    targetAllocationSlider({ equityAllocation, onSliderChange }),
    assetClassSelect(),
    regionSelect(),
    assetTypeSelect(),
    objectiveSelect(),
    strategyTypeSelect()
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
      {formItems.map((item, index) =>
        renderFormItem(item, index, index !== formItems.length - 1)
      )}
      <Form.Item>
        <Button type="primary" htmlType="submit" style={{ marginTop: '24px' }}>
          Update Portfolio
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PortfolioForm;
